import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Button from "../Button/Button"
import { included } from "./offeringData"

const OfferingTeaserStyles = styled.section`
  .teaser {
    display: grid;
    grid-template-columns: 1fr;
    gap: clamp(2rem, 5vw, 4.5rem);
    align-items: center;

    @media (min-width: 900px) {
      grid-template-columns: 1.05fr 0.95fr;
    }
  }

  .teaser__intro {
    .eyebrow {
      margin-bottom: 1.5rem;
    }
    h2 {
      font-size: clamp(2rem, 4.6vw, 3.5rem);
      line-height: 1.02;
      margin: 0 0 1.3rem;
    }
    .accent {
      color: var(--color-gold-500);
    }
    .teaser__lead {
      color: var(--color-ash);
      font-size: var(--text-lead);
      line-height: 1.5;
      margin: 0;
      max-width: 48ch;
    }
  }

  .teaser__btns {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: clamp(1.75rem, 4vh, 2.5rem);
  }

  .teaser__list {
    list-style: none;
    margin: 0;
    padding: clamp(1.4rem, 2.5vw, 2.25rem) clamp(1.4rem, 2.5vw, 2.25rem)
      calc(clamp(1.4rem, 2.5vw, 2.25rem) - 0.85rem);
    background: var(--color-panel);
    border: 1px solid var(--color-line);
    border-radius: 18px;

    li {
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 0.85rem 0;
      border-bottom: 1px solid var(--color-line);
      color: var(--color-paper);
      font-weight: 500;

      &:last-child {
        border-bottom: none;
      }

      .num {
        font-family: var(--font-display);
        font-weight: 600;
        color: var(--color-gold-500);
        min-width: 1.7rem;
      }
    }
  }
`

const OfferingTeaser = () => {
  return (
    <OfferingTeaserStyles className="section">
      <div className="container container__tight teaser">
        <div className="teaser__intro">
          <p className="eyebrow">Custom Websites</p>
          <h2>
            Custom websites, built from scratch
            <span className="accent">.</span>
          </h2>
          <p className="teaser__lead">
            A complete custom site for performers, artists, and creatives — a
            strong first impression that looks effortless on every screen. One
            flat project fee from $1,500, plus optional add-ons for whatever
            your project needs.
          </p>
          <div className="teaser__btns">
            <Button
              as={Link}
              to="/custom-websites"
              text="See what’s included"
              arrow
            />
            <Button as={Link} to="/contact" text="Start your project" ghost />
          </div>
        </div>

        <ul className="teaser__list">
          {included.map((item, index) => (
            <li key={index}>
              <span className="num">{`0${index + 1}`}</span>
              {item.title}
            </li>
          ))}
        </ul>
      </div>
    </OfferingTeaserStyles>
  )
}

export default OfferingTeaser
